<!--专家休假-->
<template>
  <div>
    <a-card title="我的休假记录">
      <a-button slot="extra"
                type="primary"
                @click="()=>seetingVisible=true">新增休假</a-button>
      <a-table :columns="columns"
               :rowKey="record => record.id"
               :pagination="false"
               :data-source="expertLeaveRecordList">
        <template slot="status"
                  slot-scope="record">
          <a-tag color="green"
                 v-if="isEfficacious(record.leaveStartTime,record.leaveEndTime,record.state)">有效</a-tag>
          <a-tag v-else>已结束</a-tag>
        </template>
        <template slot="action"
                  slot-scope="record">
          <a-button type="danger"
                    v-if="isLeaveRecord(record.leaveStartTime,record.leaveEndTime) && record.state=='0'"
                    :loading="saveLoading"
                    @click="onSubmitTerminationLeave">终止休假</a-button>
          <a-button v-else-if="record.state=='0'"
                    @click="deleteLeaveRecord(record)">删除</a-button>
          <span v-else>/</span>
        </template>
      </a-table>
      <a-modal title="新增休假"
               :dialog-style="{top:'20px'}"
               width="60%"
               okText="提交"
               :confirmLoading="saveLoading"
               v-model="seetingVisible"
               @ok="onSubmit">
        <a-form-model :model="expertLeaveForm"
                      ref="expertLeaveForm"
                      :rules="rules"
                      class="exi_form item_100"
                      :label-col="{ flex: '0 0 auto' }"
                      :wrapper-col="{ span: 24 }">
          <a-row :gutter="20"
                 type="flex"
                 align="middle">
            <a-col :span="10">
              <a-form-model-item label="休假开始时间"
                                 prop="leaveStartTime">
                <a-date-picker class="w-100"
                               v-model="expertLeaveForm.leaveStartTime"
                               :disabled-date="disabledStartDate"
                               :format="dateFormatStr"
                               :value-format="dateFormatStr"
                               placeholder="开始时间" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="休假结束时间"
                                 prop="leaveEndTime"
                                 :rules="[{ required: !leaveRecordType, message: '请输入休假结束时间', trigger: 'change' }]">
                <a-date-picker class="w-100"
                               v-if="!leaveRecordType"
                               v-model="expertLeaveForm.leaveEndTime"
                               :disabled-date="disabledEndDate"
                               :format="dateFormatStr"
                               :value-format="dateFormatStr"
                               placeholder="结束时间" />
                <span class="color-red"
                      v-else>长期</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-checkbox v-model="leaveRecordType"
                          @change="onChangeLeaveRecordType">
                长期休假
              </a-checkbox>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="休假原因"
                                 prop="leaveReason">
                <a-textarea v-model="expertLeaveForm.leaveReason"
                            auto-size
                            placeholder="请输入休假原因" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import { GetExpertByUserId, SetLeaveRecordTime, SetTerminationLeave, GetExpertLeaveRecordByExpertId, DeleteExpertLeaveRecordByValid } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { IsLeaveRecord } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import moment from 'moment'

export default {
  name: 'ExpertLeaveRecord',
  data () {
    return {
      saveLoading: false,
      seetingVisible: false,
      dateFormatStr: 'YYYY-MM-DD',
      leaveRecordType: false,
      inLeaveRecord: false,//是否正在休假
      expertInfo: {},
      timeStep: {
        minuteStep: 30,
        format: 'HH:mm',
        defaultValue: moment('09:00', 'HH:mm')
      },
      endTimeStep: {
        minuteStep: 30,
        format: 'HH:mm',
        defaultValue: moment('23:00', 'HH:mm')
      },
      expertLeaveForm: {
        leaveStartTime: null,
        leaveEndTime: null,
        expertId: '',
        leaveReason: '',
      },
      expertLeaveRecordList: [],
      rules: {
        leaveReason: [{ required: true, message: '请输入休假原因', trigger: 'change' }],
        leaveStartTime: [{ required: true, message: '请输入休假开始时间', trigger: 'change' }],
      },
      columns: [
        {
          title: '填报日期', dataIndex: 'addTime', key: 'addTime', customRender: (text) => {
            return text ? moment(text).format('YYYY-MM-DD') : ''
          }
        },
        {
          title: '休假开始日期', dataIndex: 'leaveStartTime', key: 'leaveStartTime', customRender: (text) => {
            return text ? moment(text).format('YYYY-MM-DD') : ''
          }
        },
        {
          title: '休假结束日期', dataIndex: 'leaveEndTime', key: 'leaveEndTime', customRender: (text) => {
            return text ? moment(text).format('YYYY-MM-DD') : '长期'
          }
        },
        { title: '休假原因', dataIndex: 'leaveReason' },
        {
          title: '状态', align: 'center', scopedSlots: { customRender: 'status' }
        },
        { title: '操作', width: '120px', align: 'center', scopedSlots: { customRender: 'action' } }]
    }
  },
  created () {
    this.getExpert()
  },
  computed: {
    // 休假时间是否有效
    isEfficacious () {
      return function (leaveStartTime, leaveEndTime, state) {
        if (state == '0') {
          const now = moment()
          return ((leaveStartTime && !leaveEndTime) || (now.isSameOrBefore(leaveEndTime, 'day') && now.isSameOrAfter(leaveStartTime, 'day')) || now.isSameOrBefore(leaveStartTime, 'day'))
        }
        return false
      }
    }
  },
  methods: {
    isLeaveRecord: IsLeaveRecord,
    async getExpertLeaveRecordByExpertId (expertId) {
      let res = await GetExpertLeaveRecordByExpertId(expertId, '')
      if (res.code == 200) {
        const result = res.result
        this.expertLeaveRecordList = result
      }
    },
    async getExpert () {
      try {
        let res = await GetExpertByUserId()
        const result = res.result
        this.expertInfo = result
        const notExtractStartTime = result.notExtractStartTime
        const notExtractEndTime = result.notExtractEndTime
        if (notExtractStartTime && !notExtractEndTime) {
          // 长期
          this.leaveRecordType = true
        }
        const today = moment()
        const dateFormatStr = this.dateFormatStr
        const isAfter = today.isAfter(notExtractEndTime)

        let leaveStartTime = null
        let leaveEndTime = null
        if (notExtractStartTime && !isAfter) {
          leaveStartTime = moment(notExtractStartTime, dateFormatStr)
        }
        if (notExtractEndTime && !isAfter) {
          leaveEndTime = moment(notExtractEndTime, dateFormatStr)
        }
        this.expertLeaveForm = {
          expertName: result.expertName,
          expertId: result.id,
        }
        this.inLeaveRecord = IsLeaveRecord(notExtractStartTime, notExtractEndTime)
        this.getExpertLeaveRecordByExpertId(result.id)
      } catch (e) {
        this.$message.error("获取信息失败")
      }
    },
    disabledStartDate (current) {
      const endValue = this.expertLeaveForm.leaveEndTime
      let perDay = moment(moment().format('YYYY-MM-DD'))
      let currentDay = moment(current.format('YYYY-MM-DD'))
      if (endValue) {
        let endMoment = moment(moment(endValue).format('YYYY-MM-DD'))
        return currentDay && currentDay < perDay || currentDay > endMoment
      }
      return currentDay && currentDay < perDay
    },
    disabledEndDate (current) {
      const startValue = this.expertLeaveForm.leaveStartTime
      let perDay = moment(moment().format('YYYY-MM-DD'))
      let currentDay = moment(current.format('YYYY-MM-DD'))
      if (startValue) {
        let startMoment = moment(moment(startValue).format('YYYY-MM-DD'))
        return currentDay < startMoment
      }
      return currentDay && currentDay < perDay
    },
    onChangeLeaveRecordType (e) {
      const value = e.target.checked
      if (value) {
        this.expertLeaveForm.leaveEndTime = null
        if (!this.expertLeaveForm.leaveStartTime) {
          this.expertLeaveForm.leaveStartTime = moment().format(this.dateFormatStr)
        }
      }
    },
    onSubmit () {
      const that = this
      if (this.inLeaveRecord) {
        this.$warning({ title: "您已在休假期间，请进行终止休假后再新增休假" })
        return
      }
      if (!this.leaveRecordType && (!this.expertLeaveForm.leaveStartTime || !this.expertLeaveForm.leaveEndTime)) {
        this.$warning({ title: "休假开始时间和休假结束时间不能为空" })
        return
      }
      this.$refs.expertLeaveForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        if (this.expertLeaveForm.leaveReason.trim() == '') {
          this.$warning({ title: "休假原因不能为空" })
          return
        }
        this.$confirm({
          title: '确定提交休假吗?',
          onOk () {
            that.handleSubmit()
          },
        })
      })
    },
    // 结束休假
    onSubmitTerminationLeave () {
      const that = this
      this.$confirm({
        title: '确定结束休假吗?',
        onOk () {
          that.handleSubmit(true)
        },
      })
    },
    async handleSubmit (isTerminationLeave) {
      this.saveLoading = true
      let res
      if (isTerminationLeave) {
        res = await SetTerminationLeave(this.expertLeaveForm)
      } else {
        res = await SetLeaveRecordTime(this.expertLeaveForm)
      }
      if (res.code == 200) {
        this.$message.success(isTerminationLeave ? '提交结束休假成功' : '提交休假成功')
      } else {
        this.$message.error(res.msg)
      }
      this.getExpert()
      this.saveLoading = false
      this.seetingVisible = false
    },
    deleteLeaveRecord (record) {
      const that = this
      this.$confirm({
        title: '确定删除休假记录吗?',
        onOk () {
          that.handleDeleteLeaveRecord(record)
        },
      })
    },
    async handleDeleteLeaveRecord (record) {
      const res = await DeleteExpertLeaveRecordByValid(record)
      if (res.code == 200) {
        this.$message.success('删除成功')
        this.getExpertLeaveRecordByExpertId(this.expertInfo.id)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.flex-center {
  width: 100%;
  display: flex;
  justify-content: center;
}
.w-100 {
  width: 100%;
}
.color-red {
  color: red;
}
</style>
